<fa-icon icon="exclamation-triangle" style="font-size: 70px;text-align: center;height: 50vh; display: block; transform: translateY(50%)"></fa-icon>